let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k25wl")).then(() => parcelRequire('9dISB'));